import React from "react";

import { ArrowRightOutlined } from "@ant-design/icons";
import { Button } from "antd";

import "./CreditPurchaseActionCard.css";

export default function CreditPurchaseActionCard({
  icon,
  title,
  description,
  actionLabel,
  actionType = "primary",
  onAction,
  loading = false,
  disabled = false,
}) {
  const isPrimary = actionType === "primary";
  const showAction = Boolean(actionLabel);

  return (
    <article className="CreditPurchaseActionCard">
      <div className="CreditPurchaseActionCard__Copy">
        {(icon || title) && (
          <div className="CreditPurchaseActionCard__TitleRow">
            {icon && (
              <span className="CreditPurchaseActionCard__Icon" aria-hidden>
                {icon}
              </span>
            )}
            {title && (
              <h3 className="CreditPurchaseActionCard__Title">{title}</h3>
            )}
          </div>
        )}
        {description && (
          <p className="CreditPurchaseActionCard__Description">{description}</p>
        )}
      </div>

      {showAction && (
        <Button
          type={isPrimary ? "primary" : "text"}
          icon={<ArrowRightOutlined />}
          iconPosition="end"
          onClick={onAction}
          loading={loading}
          disabled={disabled}
        >
          {actionLabel}
        </Button>
      )}
    </article>
  );
}
